import React, { useEffect, useState, useRef } from "react";
import {useSpring} from '@react-spring/core'
import {animated} from '@react-spring/web'
import {useThree} from "react-three-fiber";

import { Html } from "@react-three/drei"
import * as THREE from "three";

import './Titol.css';

const Titol = (props) => {
	const [shown, setShown] = useState(0)
	const [visible, setVisible] = useState(1)

	const ref = useRef()

	const {camera} = useThree()

	useEffect(() => {
		if (! shown && props.visible) {
			setShown(1);
			setVisible(0);

			const position = new THREE.Vector3();
			camera.getWorldDirection(position);

			position.y = 0;
			position.multiplyScalar(2).add(camera.position);

			ref.current.position.copy(position);
		}
	}, [props.visible])

	const styleHtml = useSpring({
		opacity: shown ? 1 : 0,
		config: { duration: 1000 },
	})

	const styleH1 = useSpring({
		opacity: visible ? 1 : 0,
		config: { duration: 5000 },
		delay: 11000
	})

	const lang = (typeof window.lang === 'undefined' || window.lang === '' ? 'ca' : window.lang);
	let titol = 'Itineraris Posthumanistes';
	switch (lang) {
		case 'es':
			titol = 'Itinerarios Posthumanistas';
			break;

		case 'en':
			titol = 'Posthumanist Itineraries';
			break;
	}

	return (
		<group ref={ref}>
			<Html

				className={"titol"}
			>
				<animated.div style={styleHtml}>
					<animated.h1 style={styleH1}>
						{titol}
					</animated.h1>
				</animated.div>
			</Html>
		</group>
	);
}

export default Titol;
